import Service from "../../AuthService";

const SaveExportation = {
    getSaveExportation(data) {
        return Service.get("/save_exportation?page="+data.page+"&id="+data.id);
    },
    showSaveExportation(id) {
        return Service.get("/save_exportation/" + id);
    },
    updateSaveExportation(id, data) {
        return Service.post("/save_exportation/" + id, data);
    },
    createSaveExportation(data) {
        return Service.post("/save_exportation", data);
    },
    deleteSaveExportation(id) {
        return Service.delete("/save_exportation/" + id);
    },
    searchSaveExportation(data){
        return Service.post('/save_exportation_search',data);
    },
    getInvoiceByDriver(id){
        return Service.get("/invoice_by_driver?id="+id);
    },
    saveLog(data){
        return Service.post("/save-log-driver",data);
    }
};

export default SaveExportation;

